<script setup>
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";
import LocaleSwitcher from "@/components/common/locale/LocaleSwitcher.vue";
import RegisterInnerForm from '@/components/register/new/RegisterInnerForm.vue';
const { t } = useI18n();
const i18n = useI18n();
const imgYautyPath = "../public/assets/login/login_logo.svg";
const imgLogginPath = '../public/assets/login/Claus_w.jpg';

let locale = ref(i18n.locale)
function onChangeInput(newVal) {
  locale.value = newVal;
  localStorage.setItem('yautyLanguage', newVal);
}

// Estils concrets per  ala app de google
const ua = navigator.userAgent.toLowerCase();
if (ua.includes('gsa')) {
  document.documentElement.classList.add('google-app-browser');
};

onMounted(() => {
  if (localStorage.getItem('yautyLanguage')) {
    locale.value = localStorage.getItem('yautyLanguage') ?? 'es';
  }
});
</script>
<template>
		<section class="register-container">
			<div class="register-section--left">
				<img :src="imgLogginPath" />
			</div>
			<div class="register-section--right">
				<div class="register-logo">
					<img :src="imgYautyPath" />
				</div>
				<div class="register-message_1">
					{{ t('register.create_account') }}
				</div>
				<div class="register-form">
					<RegisterInnerForm />
				</div>
			</div>
		</section>
		<div class="language-selector">
			<div class="language__selector">
				<LocaleSwitcher :lang="locale" @changeInput="onChangeInput" :mode="1"/>
			</div>
		</div>
	
	</template>

<style lang="scss" scoped>
.register-container {
  display: grid;
  grid-template-columns: 50% 50%;
  justify-content: center;
  height: calc(100vh - 60px);
  .register-section--left {
    width: 50dvw;
    height: 100dvh;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .register-section--right {
    display: flex;
    flex-direction: column;
    padding-left: 8rem;
    margin-top: 10dvh;
    height: 90vh;
    position: relative;
    
    max-width: 466px; 
    
    .register-message_1 {
      text-align: left;
      font: normal normal normal 51px/29px 'CircularStd-Book';
      letter-spacing: -2.55px;
      color: #000000;
      margin-top: 60px;
      line-height: 0.9;
    }
    .register-message_2 {
      text-align: left;
      font: normal normal normal 18px/29px 'CircularStd-Book';
      letter-spacing: -0.9px;
      color: #000000;
      opacity: 1;
      margin-top: 28px;
    }
    .register-form {
      margin-top: 16px;
    }
  }
  @media (min-width: 360px) and (max-width: 768px) {
    grid-template-columns: 0% 100%;
    .register-section--left {
      width: 0;
      img {
        width: 0;
        object-fit: cover;
      }
    } 
    .register-section--right {
      padding-left: 4rem;
    }
  }
  

  @media (min-width: 768px) and (max-width: 1300px) {
    grid-template-columns: 50% 50%;
    .register-section--left {
      width: 50dvw;
      img {
        width: 50dvw;
        object-fit: cover;
      }
    }
    .register-section--right {
      padding-left: 0rem;
    }
  }
}
.language-selector {
    position: absolute;
    bottom: -15px;
    right: 2rem;
    width: 175px;
    z-index: 5;
    margin-bottom: 0.6rem;
	 
  @media (min-width: 1301px) {
    margin-bottom: 2.5rem;
  }
    
}

@media (max-width: 600px) {
  .register-container {
    grid-template-columns: auto;
    max-width: 80%;
    margin: auto;
    .register-section--left {
      display: none;
    }
    .register-section--right {
      margin-top: 10dvh;
      padding-left: inherit;
      height: 90dvh;
      text-align: center;
      .register-message_1, .register-message_2 {
        text-align: center;
      }
    }
  }
}
@media (max-width: 580px) {
  
  .language-selector {
    bottom: 3dvh;
	left: 50%;
	transform: translateX(-50%);
	right: unset;
  }
}

@media (min-width: 581px) and (max-width: 1024px) and (orientation: portrait) {
  .register-container {
    grid-template-columns: auto;
    max-width: 80%;
    margin: auto;
    height: 100vh;
    .register-section--left {
      display: none;
    }
    .register-section--right {
      padding-left: inherit;
      max-width: 100%;
      margin-top: 10dvh;
      height: 90vh;
      text-align: center;
      .register-message_1, .register-message_2 {
        text-align: center;
      }
    }
  }
  .language-selector {
    position: absolute;
		right: auto;
		bottom: 10dvh;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		width: 175px;
		background: transparent;
		justify-self: center;
  }
}


//Per a tablet en landscape
@media (min-width: 769px) and (max-width: 1300px) and (orientation: landscape)  {

  .register-container {
    grid-template-columns: auto;
    max-width: 80%;
    margin: auto;
    height: 80vh;
    .register-section--left {
      display: none;
    }
    .register-section--right {
      padding-left: inherit;
      max-width: 90dvh;
      margin-top: 10dvh;
      text-align: center;
      height: 75vh;
      .register-message_1, .register-message_2 {
        text-align: center;
      }
      
    }
  }
  .language-selector {
    right: 1rem;
  }
}

@media (min-width: 1301px) and (max-width: 1365px) and (orientation: landscape)  {
  .register-section--right {
    padding-left: 3rem !important;
  }
  

}


/* Center language selector vertically & horizontally on portrait screens below 1024px */
@media (max-width: 1024px) and (orientation: portrait) {
  .language-selector {
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
  }
}

.recovery{
	  @media (min-width: 1301px) and (orientation: landscape) {
	margin-bottom: 2.5rem;
	
  }
}

@media (max-width: 576px){
  .register-container{
    height: 110dvh !important;
  }
  .language-selector {
    bottom: 7dvh !important;
  }
}

@media (max-width: 950px) and (orientation: landscape) {
  .register-section--right {
	margin-top: 15dvh !important;
	height: 150dvh !important;
	top: 0;
	padding-bottom: 8rem !important;
	max-width: none !important;
  align-items: center !important;
  padding-left: 0 !important;
  }
  .register-container{
	height: 175dvh !important;
	min-height: 700px;
	padding-bottom: 6rem !important;
  }
  
  .language-selector {
    position: absolute !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    right: auto !important;
    margin: 0 !important;
    z-index: 10 !important;
	bottom: 2dvh !important;
  }
}


@supports (-moz-appearance: none) {
  @media (min-width: 769px) and (max-width: 1300px) and (orientation: landscape)  {
    .language-selector{
      margin-bottom: 3rem !important;
      right: 2rem !important;
    }
  }
}
@media (max-width: 620px) and (orientation: portrait) {
	.google-app-browser  {
		.login-section--right {
			height: calc(85dvh + 20dvh) !important;
		}
		.language-selector {
			bottom: 0 !important;
		}
	}
}
</style>
